class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.handleSearchDrawerToggle = this.handleSearchDrawerToggle.bind(this);
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector(".bosSearchDrawerItems");
    this.bosSearchDrawerContainer = this.querySelector(
      ".bosSearchDrawerContainer",
    );
    this.bosSearchDrawerBtn = document.querySelector(".bosSearchDrawerBtn");
    this.overlay = document.querySelector(".bosSearchDrawerContainerOverlay");
    this.bindEvents();
  }

  bindEvents() {
    this.input?.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    this.input?.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        const searchTerm = this.input.value.trim();
        if (searchTerm) {
          window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
        }
      }
    });

    this.bosSearchDrawerBtn?.addEventListener(
      "click",
      this.handleSearchDrawerToggle,
    );

    this.overlay?.addEventListener("click", () => {
      this.classList.remove("is-open");
      this.overlay.classList.add("hidden");
    });

    this.bosSearchDrawerContainer?.addEventListener("click", (e) => {
      if (!e.target.closest(".bosSearchDrawerItem")) {
        this.input?.focus();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.classList.contains("is-open")) {
        this.classList.remove("is-open");
        this.overlay?.classList.add("hidden");
      }
    });

    this.input?.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        const searchTerm = this.input.value.trim();
        if (searchTerm) {
          this.getSearchResults(searchTerm);
        }
      }
    });
  }

  onChange(e) {
    const searchTerm = e.target.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=product,article,collection&section_id=${this.sectionId}`,
    )
      .then((response) => response.text())
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".bosSearchDrawerItems").innerHTML;

        if (!this.predictiveSearchResults) return;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  handleSearchDrawerToggle() {
    this.classList.toggle("is-open");
    this.overlay?.classList.toggle("hidden");
    if (this.classList.contains("is-open")) {
      setTimeout(() => this.input?.focus(), 50);
    }
  }

  open() {
    this.predictiveSearchResults.style.display = "flex";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("search-drawer", SearchDrawer);


